module.exports = __webpack_public_path__ + "static/media/profile-11.bb14419d.jpeg";